export type ApiError = { status: number; code?: string; detail?: string };

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  headers.set("Accept", "application/json");
  const response = await fetch(path, { credentials: "include", ...init, headers });
  const text = await response.text();
  const data = text ? JSON.parse(text) : {};
  if (!response.ok) {
    const error: ApiError = { status: response.status, code: data.code, detail: data.detail ?? data.title };
    throw error;
  }
  return data as T;
}

export function returnTo(path = location.pathname + location.search): string {
  return `/signin?return=${encodeURIComponent(path)}`;
}
